import React from "react";
const CtGovResponse: React.FC = () => {
  return (<></>)
}
export default CtGovResponse;